export default {
    namespaced: true,
    state: {
        newsList: null,
        bread_active: null,
        bread_list: null,
    },
    getters: {},
    mutations: {
        SET_DATA(state, data) {
            eval("state." + data.name + " = data.data;");
        }
    },
    actions: {
        getNewsList(state) {
            axios.get('/api/v2/feed/abtg/')
                .then(function (response) {
                    state.commit('SET_DATA', {name: 'newsList', data: response.data});
                })
        },
    }
}
